import React, { useState, useEffect } from 'react';
import { Card } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge'; 
import api from '../../services/api';

const Dashboard = () => {
  const [stats, setStats] = useState({
    total_usuarios: 0,
    total_cursos: 0,
    total_videos: 0,
    novos_usuarios_mes: 0
  });
  const [cursosStats, setCursosStats] = useState({
    cursos_populares: [],
    cursos_por_categoria: []
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [dashboardResponse, cursosResponse] = await Promise.all([
          api.get('/admin/dashboard'),
          api.get('/admin/cursos-stats')
        ]);
        
        setStats(dashboardResponse.data);
        setCursosStats(cursosResponse.data);
      } catch (error) {
        console.error('Erro ao carregar dados:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-500"></div>
      </div>
    );
  }

  return (
    <div className="space-y-8">
      {/* Header */}
      <div>
        <h1 className="text-3xl font-bold text-white">Dashboard Administrativo</h1>
        <p className="text-slate-300 mt-2">Visão geral do sistema de cursos</p>
      </div>

      {/* Cards de Estatísticas */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <Card className="p-6 bg-slate-800/50 border-slate-700/50 backdrop-blur-sm">
          <div className="flex items-center">
            <div className="p-2 bg-blue-600/20 rounded-lg">
              <svg className="w-6 h-6 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-slate-400">Total de Usuários</p>
              <p className="text-2xl font-bold text-white">{stats.total_usuarios}</p>
            </div>
          </div>
        </Card>

        <Card className="p-6 bg-slate-800/50 border-slate-700/50 backdrop-blur-sm">
          <div className="flex items-center">
            <div className="p-2 bg-green-600/20 rounded-lg">
              <svg className="w-6 h-6 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
              </svg>
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-slate-400">Total de Cursos</p>
              <p className="text-2xl font-bold text-white">{stats.total_cursos}</p>
            </div>
          </div>
        </Card>

        <Card className="p-6 bg-slate-800/50 border-slate-700/50 backdrop-blur-sm">
          <div className="flex items-center">
            <div className="p-2 bg-purple-600/20 rounded-lg">
              <svg className="w-6 h-6 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
              </svg>
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-slate-400">Total de Vídeos</p>
              <p className="text-2xl font-bold text-white">{stats.total_videos}</p>
            </div>
          </div>
        </Card>

        <Card className="p-6 bg-slate-800/50 border-slate-700/50 backdrop-blur-sm">
          <div className="flex items-center">
            <div className="p-2 bg-yellow-600/20 rounded-lg">
              <svg className="w-6 h-6 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
              </svg>
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-slate-400">Novos Usuários</p>
              <p className="text-2xl font-bold text-white">{stats.novos_usuarios_mes}</p>
            </div>
          </div>
        </Card>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* Cursos Populares */}
        <Card className="p-6 bg-slate-800/50 border-slate-700/50 backdrop-blur-sm">
          <h3 className="text-lg font-semibold text-white mb-4">Cursos Mais Populares</h3>
          <div className="space-y-4">
            {cursosStats.cursos_populares.length > 0 ? (
              cursosStats.cursos_populares.map((curso, index) => (
                <div key={curso.id} className="flex items-center justify-between p-3 bg-slate-700/30 rounded-lg border border-slate-600/30">
                  <div>
                    <p className="font-medium text-white">{curso.titulo}</p>
                    <p className="text-sm text-slate-400">{curso.total_alunos} alunos</p>
                  </div>
                  <Badge variant="secondary" className="bg-red-600/20 text-red-400 border-red-600/30">#{index + 1}</Badge>
                </div>
              ))
            ) : (
              <p className="text-slate-400 text-center py-4">Nenhum curso encontrado</p>
            )}
          </div>
        </Card>

        {/* Cursos por Categoria */}
        <Card className="p-6 bg-slate-800/50 border-slate-700/50 backdrop-blur-sm">
          <h3 className="text-lg font-semibold text-white mb-4">Cursos por Categoria</h3>
          <div className="space-y-4">
            {cursosStats.cursos_por_categoria.length > 0 ? (
              cursosStats.cursos_por_categoria.map((categoria) => (
                <div key={categoria.categoria} className="flex items-center justify-between p-3 bg-slate-700/30 rounded-lg border border-slate-600/30">
                  <p className="font-medium text-white">{categoria.categoria}</p>
                  <Badge variant="outline" className="border-slate-600 text-slate-300">{categoria.total_cursos} cursos</Badge>
                </div>
              ))
            ) : (
              <p className="text-slate-400 text-center py-4">Nenhuma categoria encontrada</p>
            )}
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Dashboard; 